// extracted by mini-css-extract-plugin
export default {"switchContainer":"BrandSwitch_switchContainer__tS-+h","toggleText":"BrandSwitch_toggleText__JpMGQ"};